import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=6f459da6&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=6f459da6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f459da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f459da6')) {
      api.createRecord('6f459da6', component.options)
    } else {
      api.reload('6f459da6', component.options)
    }
    module.hot.accept("./PurchaseOrderList.vue?vue&type=template&id=6f459da6&scoped=true", function () {
      api.rerender('6f459da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderList.vue"
export default component.exports